'use client';

import { AD_SETTINGS } from '@/lib/adSlots';
import AdHeader from '../AdHeader';
import TravelpayoutsWidget from './TravelpayoutsWidget';

export default function TravelpayoutsHotelsAd() {
  const src =
    `https://tpwidg.com/content?trs=${AD_SETTINGS.trs}` +
    `&shmarker=${AD_SETTINGS.shmarker}` +
    `&locale=${AD_SETTINGS.locale}` +
    `&powered_by=false&campaign_id=84&promo_id=9240`;

  return (
    <div>
      <AdHeader title="Find a hotel nearby" />
      <TravelpayoutsWidget src={src} />
    </div>
  );
}
